import React, { useState, useEffect } from 'react';

//import { useParams } from 'react-router-dom';

import OperatorAcceptedConsultations from '../../components/Consultation/OperatorAcceptedConsultations'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function AcceptedConsultations() {  
  //let { userUid } = useParams();
  const { t } = useTranslation();

  return (
    <>              
      <MainBlockHeader header={t('consultation.operator.acceptedList.header')} >
      </MainBlockHeader>

      <MainBlockContainer>      
        <OperatorAcceptedConsultations />
      </MainBlockContainer>
    </>
  );  
}